/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, inject } from "@angular/core";
import { DataServiceServiceProfile } from "src/app/modules/alias/services/profile-data-service.service";
import { SharingDataService } from "src/app/shared/service/sharing-data.service";

@Component({
  selector: "app-refresh-session",
  template: ``,
  styles: [],
  standalone: true,
})
export class RefreshSessionComponent implements OnDestroy {
  private readonly dataService = inject(DataServiceServiceProfile);
  private readonly sharinDataService = inject(SharingDataService);

  subscribtionVar: any;
  groupName: any;



  refreshSession() {
    const profile = localStorage.getItem('aliasGroupName')
    this.groupName = {
      groupName: profile,
    };
    this.triggerProfileApi()
  }

  triggerProfileApi() {
    const profile = localStorage.getItem('aliasGroupName')
    this.groupName = {
      groupName: profile, observe: 'response', withCredentials: true
    };
    const payload = this.groupName;
    this.subscribtionVar = this.dataService.switchProfile(payload).subscribe(() => {
      this.sharinDataService.setProfileChanged(true)
    })
  }

  ngOnDestroy(): void {
    if (this.subscribtionVar) {
      this.subscribtionVar.unsubscribe();
    }
  }
}
